/* ==========================================================================
   Dynoforce leads meten (MEET-2, 10-10-2026)
   Een klik op WhatsApp, bellen of mailen, het versturen van een
   contactformulier (afspraak, contact, hou mij op de hoogte) en de uitkomst
   van de kentekencheck gaan als gebeurtenis naar twee ontvangers tegelijk:
   - Shopify.analytics.publish('df_lead' | 'df_kentekencheck', payload)
     -> op te vangen in een aangepaste pixel (Instellingen > Klantgebeurtenissen)
   - window.dataLayer.push({event: 'df_lead' | 'df_kentekencheck', ...payload})
     -> op te vangen in Google Tag Manager (GTM-MNMKSCCD)

   Er gaat nooit een persoonsgegeven mee: geen naam, e-mailadres of
   telefoonnummer, en ook niet het kenteken zelf. Alleen het soort lead, de
   dienst, de plek op de pagina, het pad, de taal en of er een kenteken bekend
   was (ja of nee).

   payload df_lead:          {type: whatsapp|bel|mail|formulier, dienst, bron,
                              pagina, locale, kenteken_bekend}
   payload df_kentekencheck: {uitkomst, pagina, locale}
   Geen afhankelijkheden; wordt uitgesteld geladen vanuit layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dfLeads) return;
  window.__dfLeads = true;

  /* De enige formuliervelden die we lezen, om de dienst te bepalen. Alles wat
     de bezoeker zelf intikt (naam, e-mail, telefoon, kenteken, bericht)
     blijft dicht. */
  var DIENST_VELDEN = ['contact[dienst]', 'contact[onderwerp]'];
  /* Velden waarvan we alleen kijken OF er iets in staat, nooit wat. */
  var KENTEKEN_VELDEN = ['contact[kenteken]', 'contact[auto of kenteken]'];

  function taal() {
    var l = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
    return String(l).toLowerCase().slice(0, 2) || 'nl';
  }

  function schoon(s, max) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase().slice(0, max || 100);
  }

  /* Welke dienst bij de pagina hoort, voor klikken op app, bel of mail.
     Eerst ?dienst= in de link (de afspraakpagina krijgt die mee), dan het
     pad. Buiten de dienstenpagina's weten we het niet en zeggen we dat ook. */
  function dienstVanPagina() {
    var q = '';
    try { q = new URLSearchParams(location.search).get('dienst') || ''; } catch (e) {}
    if (q) return schoon(q, 60);
    var p = location.pathname.toLowerCase();
    if (/chiptuning|stage-?[123]|tuning|bootmod/.test(p)) return 'chiptuning';
    if (/blu-?eye/.test(p)) return 'blu eye';
    if (/detailing|coating|ppf/.test(p)) return 'detailing';
    if (/carbon/.test(p)) return 'carbon';
    return 'onbekend';
  }

  /* Is er een kenteken bekend? Alleen ja of nee: uit een gevuld
     kentekenveld in het formulier, of uit het sitebrede geheugen van de
     kentekencheck (df_kenteken, zie df-data.js). */
  function kentekenBekend(form) {
    try {
      if (form) {
        var velden = form.querySelectorAll('input');
        for (var i = 0; i < velden.length; i++) {
          if (KENTEKEN_VELDEN.indexOf(schoon(velden[i].name, 80)) > -1 &&
              velden[i].value && velden[i].value.trim()) return true;
        }
      }
      if (window.DFData && window.DFData.onthoudenKenteken) return !!window.DFData.onthoudenKenteken();
      var r = JSON.parse(localStorage.getItem('df_kenteken') || 'null');
      return !!(r && r.kt);
    } catch (e) { return false; }
  }

  /* De plek op de pagina: de sectienaam uit de id van de .shopify-section
     (template--123__afspraakflow wordt afspraakflow, sections--123__header
     wordt header), of een vaste naam voor de contactregel onder de
     kentekencheck en het op-de-hoogte-blok. */
  function bronVan(el) {
    if (!el || !el.closest) return 'pagina';
    if (el.closest('[data-df-kt-status]')) return 'kentekencheck';
    if (el.closest('[data-kt-oh]')) return 'opdehoogte';
    var s = el.closest('.shopify-section');
    var id = s && s.id ? s.id.replace(/^shopify-section-/, '') : '';
    id = id.replace(/^(template|sections)--\d+__/, '');
    return schoon(id, 60) || 'pagina';
  }

  /* Naar allebei de ontvangers. Elk apart afgevangen: de een mag nooit de
     ander in de weg zitten, en geen van beide mag de pagina zelf raken. */
  function stuur(naam, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(naam, payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var rij = { event: naam };
      Object.keys(payload).forEach(function (k) { rij[k] = payload[k]; });
      window.dataLayer.push(rij);
    } catch (e) {}
  }

  function lead(type, dienst, bron, form) {
    stuur('df_lead', {
      type: type,
      dienst: dienst || 'onbekend',
      bron: bron || 'pagina',
      pagina: location.pathname,
      locale: taal(),
      kenteken_bekend: kentekenBekend(form)
    });
  }

  /* --- Klikken op app, bel en mail ------------------------------------- */
  function soortLink(href) {
    var h = String(href || '').trim();
    if (/^https:\/\/wa\.me\//i.test(h) || /^whatsapp:/i.test(h) ||
        /^https:\/\/api\.whatsapp\.com\//i.test(h)) return 'whatsapp';
    if (/^tel:/i.test(h)) return 'bel';
    if (/^mailto:/i.test(h)) return 'mail';
    return '';
  }

  /* In de capture-fase, zodat een stopPropagation ergens in een sectie de
     klik niet voor ons verbergt. De links in de contactregel van de
     kentekencheck bestaan pas na het zoeken; daarom op document. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var soort = soortLink(a.getAttribute('href'));
    if (!soort) return;
    lead(soort, dienstVanPagina(), bronVan(a), null);
  }, true);

  /* --- Contactformulieren ----------------------------------------------- */
  function contactFormulier(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if (String(form.getAttribute('action') || '').indexOf('/contact') === -1) return false;
    /* Shopify's nieuwsbriefformulier post ook naar /contact, met form_type
       customer. Een inschrijving is geen aanvraag en telt hier niet mee. */
    var ft = form.querySelector('input[name="form_type"]');
    if (ft && ft.value && ft.value !== 'contact') return false;
    return true;
  }

  function dienstVanFormulier(form) {
    var velden = form.querySelectorAll('input[type="hidden"], select');
    for (var i = 0; i < velden.length; i++) {
      if (DIENST_VELDEN.indexOf(schoon(velden[i].name, 80)) === -1) continue;
      var w = schoon(velden[i].value, 100)
        .replace(/^hou mij op de hoogte:\s*/, '')
        .replace(/^keep me posted:\s*/, '');
      if (w) return w;
    }
    return dienstVanPagina();
  }

  function bronVanFormulier(form) {
    if (form.closest('[data-kt-oh]')) return 'opdehoogte';
    if (form.closest('[data-df-af]') ||
        form.querySelector('input[type="hidden"][name="contact[Dienst]"]')) return 'afspraak';
    return 'contact';
  }

  /* In de capture-fase op document: dat is het enige moment waarop we het
     bericht zeker zien. Shopify's spamcontrole (captcha-bootstrap, hCaptcha)
     luistert op document, roept preventDefault aan en verstuurt het
     formulier na de controle zelf; en "hou mij op de hoogte" (df-kenteken.js)
     verstuurt op de achtergrond en houdt zijn bericht met stopPropagation
     bij zichzelf. Een luisteraar in de bubble-fase ziet dus nooit een
     formulier dat echt weggaat.

     Daarom hier tellen, met dezelfde geldigheidscontrole als de browser
     (een leeg of fout e-mailveld is geen lead) en voor de afspraakflow
     alleen vanuit de laatste stap: Enter in stap 1 tot en met 3 stapt door
     en is nog geen aanvraag. Hoogstens een keer per tien seconden per
     formulier, voor het geval de spamcontrole het bericht opnieuw afvuurt. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!contactFormulier(form)) return;
    if (form.checkValidity && !form.checkValidity()) return;
    var stappen = form.querySelectorAll('[data-df-af-pnl]');
    if (stappen.length && stappen[stappen.length - 1].hidden) return;
    var nu = Date.now();
    if (form.__dfLeadTs && nu - form.__dfLeadTs < 10000) return;
    form.__dfLeadTs = nu;
    lead('formulier', dienstVanFormulier(form), bronVanFormulier(form), form);
  }, true);

  /* --- Kentekencheck ----------------------------------------------------- */
  /* df-kenteken.js roept na elke uitkomst df:kentekencheck om met
     {uitkomst, pagina}; het kenteken zit daar met opzet niet in. */
  document.addEventListener('df:kentekencheck', function (e) {
    var d = e && e.detail ? e.detail : {};
    stuur('df_kentekencheck', {
      uitkomst: schoon(d.uitkomst, 40) || 'fout',
      pagina: d.pagina || location.pathname,
      locale: taal()
    });
  });
})();
